/* eslint-disable @typescript-eslint/no-explicit-any */
export const USERS_ACTIONS = "/USERS-ACTIONS";

export enum UserAction {
  updateBalance = "updateBalance",
  updateLevelHost = "updateLevelHost",
  updateLevelSpectator = "updateLevelSpectator",
  updateAgencyBalance = "updateAgencyBalance",
  payroll = "payroll",
}

export interface UserActionReturn {
  action: UserAction;
  extendData?: Record<string, any>;
  userId: number;
}
